<template>
  <div>
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row align="center">
          <v-col align="start" class="py-2">{{
            $t("title.titleReport")
          }}</v-col>
          <v-spacer />
          <!-- Sheet name must be max 31 characters -->
          <v-btn
            v-if="selectedStatisticType.Key"
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="
              () => {
                isExcel = true;
                getTableList();
              }
            "
          >
            {{ $t("buttons.excelExport") }}
          </v-btn>
          <v-btn
            @click="clearPage()"
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
          >
            {{ $t("buttons.clearFilter") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-row align="center" justify="start">
          <!-- Range date picker start -->
          <v-col cols="3">
            <v-menu
              ref="datePickerRef"
              v-model="datePickerModel"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('labels.selectDateRange')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" locale="tr-TR" range>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="
                    datePickerModel = false;
                    dates = [];
                  "
                >
                  {{ $t("buttons.cancel") }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.datePickerRef.save(date);
                    saveDatePicker();
                  "
                >
                  {{ $t("buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <!-- Range date picker end -->
          <!-- Statistic type select start -->
          <v-col cols="4">
            <v-select
              v-model="selectedStatisticType"
              :items="statisticsList"
              :label="$t('labels.selectStatistic')"
              item-text="Value"
              return-object
              item-value="Key"
              @change="selectStatistic(selectedStatisticType)"
            ></v-select>
          </v-col>
          <!-- Statistic type select end -->
          <!-- Statistic type select start -->
          <v-col cols="2" v-if="selectedStatisticType.Key === 'Count_Post'">
            <v-select
              v-model="selectedCountPostType"
              :items="countPostTypes"
              :label="$t('labels.selectCountPostType')"
              item-text="Value"
              return-object
              item-value="Key"
              @change="selectCountPostType(selectedCountPostType)"
            ></v-select>
          </v-col>
          <!-- Statistic type select end -->
          <!-- Tag Id Input Start -->
          <v-col
            cols="3"
            v-if="
              selectedStatisticType.Key === 'GetPostTagCounts' ||
                selectedStatisticType.Key === 'MostLikedPostsReport' ||
                selectedStatisticType.Key === 'MostCommentedPostsReport'
            "
          >
            <v-autocomplete
              @change="getMostPosts(groupId)"
              item-text="Name"
              item-value="Id"
              v-model="groupId"
              :items="groups"
              :label="$t('labels.regions')"
            />
          </v-col>
          <!-- Tag Id Input End -->
          <!-- Pagination select box start -->
          <v-col cols="2" class="ml-auto">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
          <!-- Pagination select box end -->
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{ disablePagination: true, disableItemsPerPage: true }"
          :no-data-text="$t('description.noList')"
        >
          <!-- Commented due to status of STATUS column -->
          <!-- <template v-slot:item.Status="{ item }">
                                                    <v-chip v-if="item.Status == 1" class="ma-2" small color="primary">
                                                      {{ $t("labels.tooltipActive") }}
                                                    </v-chip>
                                                    <v-chip v-if="item.Status == 0" class="ma-2" small color="primary">
                                                      {{ $t("labels.tooltipPassive") }}
                                                    </v-chip>
                                                  </template> -->
        </v-data-table>
        <!-- Page number div start -->
        <div
          class="text-xs-center pt-2 md4 lg4 d-flex justify-center align-center"
        >
          <div
            class="d-flex justify-center align-center elevation-1 rounded-circle"
          >
            <v-btn icon @click="changePage(-1)">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </div>
          <div
            class="d-flex justify-center align-center elevation-1 rounded-circle mx-2"
            style="min-width: 36px; min-height: 36px; background-color: #7542a0; color: white; font-weight: 500;"
          >
            {{ page }}
          </div>
          <div
            class="d-flex justify-center align-center elevation-1 rounded-circle"
          >
            <v-btn icon @click="changePage(1)">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportService from "../services/ReportService";
import GroupService from "../services/GroupService";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  data: () => ({
    url: "",
    // For table listing
    options: {
      itemsPerPage: 15,
    },
    tableData: [],
    selectedStatisticType: {},
    selectedCountPostType: {},
    statisticsList: [],
    headers: [],
    groupId: "",
    groups: [],
    dates: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    datePickerModel: false,
    isExcel: false,
    groupId: "",
    page: 1,
    itemsPerPage: 10,
    perPageValues: [
      {
        name: "10",
        value: 10,
      },
      {
        name: "15",
        value: 15,
      },
      {
        name: "30",
        value: 30,
      },
      {
        name: "50",
        value: 50,
      },
      {
        name: "100",
        value: 100,
      },
    ],
    countPostTypes: [
      {
        Key: "video",
        Value: "Video",
      },
      {
        Key: "image",
        Value: "Resim",
      },
      {
        Key: "text",
        Value: "Metin",
      },
    ],
    hasNextPage: false,
  }),
  computed: {
    // Computes dates that is displaying
    dateRangeText() {
      let arr = this.dates.map((date) => {
        return convertToLocal(date);
      });

      arr = arr.join(" - ");
      return arr;
    },
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
  },
  mounted() {
    this.url = process.env.VUE_APP_API_URL;
    this.setup();
  },
  methods: {
    //Page setup
    setup() {
      this.getStatisticsList();
    },

    //Change list pagination page
    changePage(direction) {
      const newPage = this.page + direction;
      if (newPage < 1) return;

      this.page = newPage;
      this.getTableList();
    },

    /**
     * Get Group List
     */
    //Loads page list
    getGroupList() {
      GroupService.getGroups("Region")
        .then((res) => {
          this.groups = [
            {
              Id: "",
              Name: "Tümü",
            },
            ...res.data,
          ];
        })
        .catch((err) => {
          if (res.status == 401) {
            window.showInfo(
              this.$t("description.authorizationError"),
              "standart",
              "info"
            );
            this.logout();
          } else {
            window.showError(err);
          }
        })
        .then(() => {});
    },

    downloadFile(data, fileName = "sampleFile", extension = "pdf") {
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.${extension}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },

    //Fill's the module list
    getTableList() {
      console.log("this.dates >> ", this.dates);
      let startDate = this.dates[0];
      let endDate = this.dates[1];

      if (this.dates.length > 0 && startDate >= endDate) {
        window.showInfo(
          this.$t("description.invalidDatePick"),
          "standart",
          "error"
        );
        //If only groups selected, empty date picker
        this.dates = [];
        startDate = "";
        endDate = "";
      }

      if (startDate === undefined && endDate === undefined) {
        startDate = "";
        endDate = "";
      }

      if (
        this.selectedStatisticType.Key === "Count_Post" &&
        !this.selectedCountPostType.Key
      ) {
        return;
      }

      if (
        this.selectedStatisticType.Key === "GetPostTagCounts" ||
        this.selectedStatisticType.Key === "MostLikedPostsReport" ||
        this.selectedStatisticType.Key === "MostCommentedPostsReport"
      ) {
        this.getGroupList();
      }

      if (this.selectedStatisticType.Key) {
        this.$store.state.loadingStatus = true;

        ReportService.getReport(
          this.selectedStatisticType.Key,
          startDate,
          endDate,
          this.selectedCountPostType.Key,
          this.itemsPerPage,
          this.page,
          this.isExcel,
          this.groupId
        )
          .then((res) => {
            if (this.isExcel) {
              console.log("Response Data > ", res.data);
              this.downloadFile(
                res.data,
                `report_${this.selectedStatisticType.Key.replace(
                  "get",
                  ""
                )}_${new Date().toISOString()}`,
                "xlsx"
              );
              this.isExcel = false;
            } else {
              this.tableData = [];
              this.headers = [];
              res.data.Headers.map((header) => {
                let tempObj = {
                  text: header.Text,
                  value: header.Value,
                  align: "start",
                  sortable: false,
                };
                this.headers.push(tempObj);
              });

              this.tableData = res.data.Result;
              //Pagination operations
              this.options.itemsPerPage = this.itemsPerPage;
              // Set hasNextPage based on whether we got any results
              this.hasNextPage =
                res.data.Result && res.data.Result.length === this.itemsPerPage;
            }
          })
          .catch((err) => {
            window.handleServiceError(err);
            this.$store.state.loadingStatus = false;
          })
          .finally(() => {
            this.$store.state.loadingStatus = false;
            axios.defaults.timeout = 40 * 1000;
          });
      }
    },

    //Get statistic types
    getStatisticsList() {
      ReportService.getStatistics()
        .then((res) => {
          this.statisticsList = res.data;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {});
    },

    //Function that activates with date picker selection
    saveDatePicker() {
      let startDate = this.dates[0];
      let endDate = this.dates[1];
      if (this.dates.length > 0 && startDate >= endDate) {
        window.showInfo(
          this.$t("description.invalidDatePick"),
          "standart",
          "error"
        );
        //If only groups selected, empty date picker
        this.dates = [];
        startDate = "";
        endDate = "";
        return;
      }

      if (startDate === undefined && endDate === undefined) {
        startDate = "";
        endDate = "";
        return;
      }
      this.getTableList();
    },

    selectStatistic() {
      if (this.selectedStatisticType.Key) {
        this.selectedCountPostType = {};
        this.tableData = [];
        this.headers = [];
        this.page = 1;
        this.groupId = "";
      }
      this.getTableList();
    },

    selectCountPostType(selectedCountPostType) {
      if (this.selectedCountPostType.Key) {
        this.page = 1;
      }
      this.getTableList();
    },

    getMostPosts(groupId) {
      if (!groupId) {
        this.groupId = "";
      } else {
        this.groupId = groupId;
      }

      this.page = 1;
      this.getTableList();
    },

    clearPage() {
      this.dates = [];
      this.tableData = [];
      this.headers = [];
      this.selectedStatisticType = {};
      this.selectCountPostType = {};
      this.itemsPerPage = 10;
      this.options.itemsPerPage = this.itemsPerPage;
      this.page = 1;
      this.otherData = [];
      this.groupId = "";
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },

    ...mapActions(["getMenuData"]),
  },
};
</script>

<style></style>
